// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormPopupGetPriceServices
{
	#app;
	#servicesId = null; // Инициализация свойства для хранения id услуги
	constructor(rootNode, servicesId): void
	{
		this.rootNode = document.querySelector(rootNode);
		this.#servicesId = servicesId;
	}
	// Метод для установки id услуги
	setServicesId(servicesId): void
	{
		this.#servicesId = servicesId;
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form :services-id="servicesId"/>
				</div>
				`,
			data: () => ({
				servicesId: this.#servicesId // Передача id услуги в данные компонента
			}),
		});
		this.#app.mount(this.rootNode);
	}
}
